import React, { useState, useEffect, useMemo } from "react";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./CharacterNew.scss";

const CharacterNew = () => {
  // Définition du titre de la page
  UseTitle("Création d'un personnage");

  const { userId } = useAuth();
  const [step, setStep] = useState(1);

  // Elements character start
  const [characterName, setCharacterName] = useState(""); // TODO : remettre à vide ""
  const [characterNickname, setCharacterNickname] = useState("");
  const [characterDescription, setCharacterDescription] = useState("");
  const [characterGender, setCharacterGender] = useState("H");
  const [characterAge, setCharacterAge] = useState(18);
  const [characterBeauty] = useState(() => Math.floor(Math.random() * 3) + 4); // Niveau de beaute aléatoirement entre 4 - 6 et non modifiable
  const [characterRegion, setCharacterRegion] = useState();
  const [characterJobsParental, setCharacterJobsParental] = useState([]);
  const [characterJob, setCharacterJob] = useState();
  const [characterAttributes, setCharacterAttributes] = useState([]);
  // Elements character end

  const [listJobsRegion, setListJobsRegion] = useState([]);
  // Liste de tous les jobs
  const [listJobs, setListJobs] = useState([]);
  // Liste des jobs possibles (non parents)
  const [listJobsFree, setListJobsFree] = useState([]);

  // Récupération de tous les attributs
  const [allAttributes, setAllAttributes] = useState([]);
  // Création du dictionnaire avec tous les attributs
  const attributeLabels = useMemo(() => {
    return Object.fromEntries(
      allAttributes.map((attribute) => [attribute.name, attribute.full_name])
    );
  }, [allAttributes]);
  // Récupération du nom complet des attributs via leurs clés
  const getAllAttributes = (key) => attributeLabels[key] || key;

  // Regroupement des skills / spells par attribut pour le job choisit
  const [attributesUsedInJob, setAttributesUsedInJob] = useState([]);

  const [attributesPointsUsed, setAttributesPointsUsed] = useState(0);
  const [attributesPointsToUse] = useState(1360);

  const [messageErrorStep1, setMessageErrorStep1] = useState([]);
  const [messageErrorStep2, setMessageErrorStep2] = useState([]);
  const [messageErrorStep3, setMessageErrorStep3] = useState([]);
  const [messageErrorStep4, setMessageErrorStep4] = useState([]);

  const [attributeFieldErrors, setAttributeFieldErrors] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [redirectTo, setRedirectTo] = useState();

  // Check de l'étape 1 : Nom, Genre, Age, Beauté, ...
  const checkStep1 = () => {
    const errors = [];

    if (!characterName) {
      errors.push("Vous devez choisir un nom");
    }
    if (!characterGender) {
      errors.push("Vous devez choisir un genre");
    } else if (characterGender !== "H" && characterGender !== "F") {
      errors.push("Le genre doit être Homme ou Femme");
    }
    if (!characterAge) {
      errors.push("Vous devez avoir un age");
    } else if (characterAge < 18) {
      errors.push("L'age doit être supérieur à 18 ans");
    }

    if (!characterBeauty) {
      errors.push("Vous devez choisir un niveau de  beauté");
    } else if (characterBeauty < 4 || characterBeauty > 6) {
      errors.push("Le niveau de beauté doit être compris entre 4 et 6");
    }

    setMessageErrorStep1(errors);
    if (errors.length > 0) return false;

    return true;
  };

  // Check de l'étape 2 : Lieu de naissance
  const checkStep2 = () => {
    const errors = [];

    if (!characterRegion) {
      errors.push("Vous devez choisir votre région de départ");
    } else if (characterRegion.is_natal !== true) {
      errors.push("Vous devez choisir une région de départ valide");
    }

    setMessageErrorStep2(errors);
    if (errors.length > 0) return false;

    return true;
  };

  // Check de l'étape 3 : Job
  const checkStep3 = () => {
    const errors = [];

    if (!characterJob) {
      errors.push("Vous devez choisir votre metier");
    } else if (characterJob.is_natal !== false) {
      errors.push("Vous devez choisir un metier valide");
    }

    setMessageErrorStep3(errors);
    if (errors.length > 0) return false;

    return true;
  };

  // Check de l'étape 4 : Attributs
  const checkStep4 = () => {
    const fieldErrors = {};
    const errors = [];

    // Récupération des clés pour les attributs à vérifier
    const keys = Object.keys(characterAttributes);

    // Initialisation du compteur d'attributs valides et du total de points utilisés
    let attributesValid = 0;
    let pointsUsed = 0;

    // Vérification de la validités de tous les attributs et dans les bonnes normes
    keys.forEach((key) => {
      // Récupération du nom complet de l'attribut
      const label = getAllAttributes(key);
      // Vérification que l'attribut n'est pas vide
      if (characterAttributes[key] === "") {
        fieldErrors[key] = (
          <>
            <strong>{label}</strong> ne peut pas être vide
          </>
        );
        return;
      }

      // Récupération de la valeur de l'attribut
      const value = Number(characterAttributes[key]);

      // Vérification que l'attribut est un nombre entier
      if (!Number.isInteger(value)) {
        fieldErrors[key] = (
          <>
            <strong>{label}</strong> doit avoir une valeur entière
          </>
        );
        return;
      }

      // Vérification que l'attribut est dans les bonnes normes
      const min = 50;
      const max = key === "rap" ? 120 : 100;

      if (value < min || value > max) {
        fieldErrors[key] = (
          <>
            <strong>{label}</strong> doit être entre <strong>{min}</strong> et{" "}
            <strong>{max}</strong>
          </>
        );
        return;
      }

      // Validation de l'attribut
      ++attributesValid;

      // Ajout des points utilisés
      pointsUsed += value;
    });

    // Vérification que tous les attributs sont renseigné
    if (attributesValid !== 17) {
      errors.push(
        `Vous devez encore renseigner ${17 - attributesValid} attributs`
      );
    }

    // Calcule des points utilisés dans les attributs
    setAttributesPointsUsed(pointsUsed);
    if (pointsUsed > attributesPointsToUse) {
      errors.push(
        `Vous avez utilisé ${pointsUsed - attributesPointsToUse} points de trop`
      );
    } else if (pointsUsed < attributesPointsToUse) {
      errors.push(
        `Il vous reste encore ${
          attributesPointsToUse - pointsUsed
        } points à utiliser`
      );
    }

    // Enregistrement des erreurs
    setAttributeFieldErrors(fieldErrors);
    setMessageErrorStep4(errors);
    if (errors.length > 0) return false;

    return true;
  };

  const handleAddCharacter = () => {
    if (!checkStep1() || !checkStep2() || !checkStep3() || !checkStep4()) {
      return;
    }

    setIsLoading(true);

    // Convertion des attributs string en entier
    const characterAttributesInt = Object.fromEntries(
      Object.entries(characterAttributes).map(([key, value]) => [
        key,
        Number(value),
      ])
    );

    const character_data = {
      id_user: userId,
      name: characterName,
      nickname: characterNickname,
      description: characterDescription,
      gender: characterGender,
      age: characterAge,
      beauty: characterBeauty,
      job_region_id: characterRegion.id,

      parent1_id: characterJobsParental[0].id,
      parent2_id: characterJobsParental[1].id,
      job_id: characterJob.id,
      attributes: characterAttributesInt,
    };

    api
      .post("/character/", character_data)
      .then((response) => {
        setRedirectTo(`/character/${response.data.character_id}`);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  // Vérification de la validité de l'étape 1
  const isStep1Valid = useMemo(
    () => checkStep1(),
    [characterName, characterGender, characterAge, characterBeauty]
  );

  // Vérification de la validité de l'étape 2
  const isStep2Valid = useMemo(() => checkStep2(), [characterRegion]);

  // Vérification de la validité de l'étape 3
  const isStep3Valid = useMemo(() => checkStep3(), [characterJob]);

  // Vérification de la validité de l'étape 4
  const isStep4Valid = useMemo(() => checkStep4(), [characterAttributes]);

  // Vérification de la validité de l'ensemble des étapes
  const isFormValid = useMemo(
    () => isStep1Valid && isStep2Valid && isStep3Valid && isStep4Valid,
    [isStep1Valid, isStep2Valid, isStep3Valid, isStep4Valid]
  );

  // Recupération des régions de naissance pour l'etape 2
  useEffect(() => {
    api
      .get(`/jobtemplate/?is_natal=true&ordering=name&page_size=9999`)
      .then((response) => {
        // On exclut le job de base réservé pour mettre tous les skills/spells qui n'appartiennent pas à un job
        const filteredJobs = response.data.results.filter(
          (job) => job.id !== 1
        );
        setListJobsRegion(filteredJobs);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Recupération des jobs pour l'etape 3
  useEffect(() => {
    api
      .get(`/jobtemplate/?is_natal=false&ordering=name&page_size=9999`)
      .then((response) => {
        // Récupération de tous les jobs non régions
        setListJobs(response.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Mise à jour des jobs parentaux pour l'etape 3
  useEffect(() => {
    // On s'assure que la liste des jobs n'est pas vide
    if (listJobs.length === 0) return;

    // Récupération aléatoire de deux id de jobs différents pour les parents
    const firstJobId = Math.floor(Math.random() * listJobs.length);
    let secondJobId = Math.floor(Math.random() * listJobs.length);
    // Récupération aléatoire d'un id de job différent du premier
    while (secondJobId === firstJobId) {
      secondJobId = Math.floor(Math.random() * listJobs.length);
    }
    // Mise à jour de la liste des jobs parentaux
    setCharacterJobsParental([listJobs[firstJobId], listJobs[secondJobId]]);
  }, [listJobs]);

  // Mise à jour de la liste des jobs possibles pour l'etape 3
  useEffect(() => {
    // On s'assure que la liste des jobs parentaux n'est pas vide
    if (characterJobsParental.length === 0) return;

    // On exclut les jobs parentaux de la liste des jobs possibles
    const filteredJobs = listJobs.filter(
      (job) => !characterJobsParental.includes(job)
    );
    setListJobsFree(filteredJobs);
  }, [characterJobsParental]);

  // Récupération des skills / spells utilisés dans les attributs du job selectionné pour l'etape 4
  useEffect(() => {
    if (characterJob) {
      api
        .get(`/jobtemplate/${characterJob.id}/`)
        .then((response) => {
          // Récupération des skills / spells du job
          const skills = response.data.skills_templates;
          const spells = response.data.spells_templates;

          const attributesList = [];

          // Fonction pour ajouter un skill / spell à un attribut
          const addToAttribute = (attribute, skillOrSpell, type) => {
            // Recherche d'un attribut dans la liste
            let entry = attributesList.find(
              (item) => item.name === attribute.name
            );

            // Création d'un nouvel attribut s'il n'a pas été trouvé
            if (!entry) {
              entry = {
                name: attribute.name,
                full_name: attribute.full_name,
                skills: [],
                spells: [],
              };
              attributesList.push(entry);
            }

            // Ajout du skill / spell au attribut si il n'y est pas deja
            if (!entry[type].includes(skillOrSpell)) {
              entry[type].push(skillOrSpell);
            }
          };

          // Ajout des skills / spells aux attributs
          skills.forEach((skill) => {
            skill.attributes.forEach((attribute) => {
              addToAttribute(attribute, skill.name, "skills");
            });
          });
          spells.forEach((spell) => {
            spell.attributes.forEach((attribute) => {
              addToAttribute(attribute, spell.name, "spells");
            });
          });

          setAttributesUsedInJob(attributesList);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [characterJob]);

  // Recupération des attributs pour l'etape 4
  useEffect(() => {
    api
      .get(`/attributes/`)
      .then((response) => {
        setAllAttributes(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <div className="character-new">
      {isLoading && (
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement de l'application...</div>
        </div>
      )}
      {!isLoading && (
        <>
          <div className="header">
            <h1>Création d'un personnage</h1>
            <p>Etape {step} / 5</p>
          </div>
          <div className="character-create">
            {/* Etape de creation des informations générales du personnage */}
            {step === 1 && (
              <>
                <div className="step step-1">
                  <h2>Informations générales</h2>
                  <div className="step-1-input name">
                    <label htmlFor="character_name">Nom</label>
                    <input
                      type="text"
                      id="character_name"
                      placeholder="Nom du personnage"
                      value={characterName}
                      onChange={(e) => setCharacterName(e.target.value)}
                    />
                  </div>
                  <div className="step-1-input nickname">
                    <label htmlFor="character_nickname">Surnom</label>
                    <input
                      type="text"
                      id="character_nickname"
                      placeholder="Surnom du personnage"
                      value={characterNickname}
                      onChange={(e) => setCharacterNickname(e.target.value)}
                    />
                  </div>
                  <div className="gender-age">
                    <div className="step-1-input gender">
                      <label htmlFor="character_gender">Genre</label>
                      <select
                        id="character_gender"
                        value={characterGender}
                        onChange={(e) => setCharacterGender(e.target.value)}
                      >
                        <option value="H">Homme</option>
                        <option value="F">Femme</option>
                      </select>
                    </div>
                    <div className="step-1-input age">
                      <label htmlFor="character_age">Age</label>
                      <input
                        type="number"
                        id="character_age"
                        min={18}
                        value={characterAge}
                        onChange={(e) => setCharacterAge(e.target.value)}
                      />
                    </div>
                    <div className="step-1-input beauty">
                      <label htmlFor="character_beauty">Beauté</label>
                      <input
                        type="number"
                        disabled={true}
                        id="character_beauty"
                        value={characterBeauty}
                      />
                    </div>
                  </div>
                  <div className="step-1-input description">
                    <label htmlFor="character_description">Description</label>
                    <textarea
                      id="character_description"
                      value={characterDescription}
                      onChange={(e) => setCharacterDescription(e.target.value)}
                    />
                  </div>

                  {/* Messages d'erreur de l'etape 1 */}
                  {messageErrorStep1.length > 0 && (
                    <div className="error">
                      {messageErrorStep1.map((messageError, index) => (
                        <p key={index}>{messageError}</p>
                      ))}
                    </div>
                  )}
                </div>
                <div className="buttons">
                  <button
                    className={isStep1Valid ? "bt" : "bt disabled"}
                    disabled={!isStep1Valid}
                    onClick={() => setStep(2)}
                  >
                    Suivant
                  </button>
                </div>
              </>
            )}

            {/* Etape du choix du lieu de naissance */}
            {step === 2 && (
              <>
                <div className="step step-2">
                  <h2>Région de départ</h2>
                  <div className="regions">
                    {listJobsRegion.map((region) => (
                      <div
                        className={`region ${
                          characterRegion?.id === region.id ? "selected" : ""
                        }`}
                        key={region.id}
                        onClick={() => {
                          setCharacterRegion(region);
                        }}
                      >
                        <h3>{region.name}</h3>
                        <p className="description">{region.description}</p>
                        {region.skills_templates.length > 0 && (
                          <div className="skills">
                            <h4>
                              Compétences ({region.skills_templates.length})
                            </h4>
                            {region.skills_templates.map((skill) => (
                              <p key={skill.id} className="skill">
                                {skill.name}
                              </p>
                            ))}
                          </div>
                        )}
                        {region.spells_templates.length > 0 && (
                          <div className="spells">
                            <h4>Sorts ({region.spells_templates.length})</h4>
                            {region.spells_templates.map((spell) => (
                              <p key={spell.id} className="spell">
                                {spell.name}
                              </p>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Messages d'erreur de l'etape 2 */}
                  {messageErrorStep2.length > 0 && (
                    <div className="error">
                      {messageErrorStep2.map((messageError, index) => (
                        <p key={index}>{messageError}</p>
                      ))}
                    </div>
                  )}
                </div>
                <div className="buttons">
                  <button className="bt" onClick={() => setStep(1)}>
                    Précédent
                  </button>
                  <button
                    className={isStep2Valid ? "bt" : "bt disabled"}
                    disabled={!isStep2Valid}
                    onClick={() => setStep(3)}
                  >
                    Suivant
                  </button>
                </div>
              </>
            )}

            {/* Etape du choix du metier */}
            {step === 3 && (
              <>
                <div className="step step-3">
                  <h2>Métiers</h2>
                  <h3>Métiers des parents</h3>
                  <div className="jobs-parents">
                    {characterJobsParental.map((job) => (
                      <div className="job-parent" key={job.id}>
                        <h4>{job.name}</h4>
                        <p className="description">{job.description}</p>
                        {job.skills_templates.length > 0 && (
                          <div className="skills">
                            <h5>Compétences ({job.skills_templates.length})</h5>
                            {job.skills_templates.map((skill) => (
                              <p key={skill.id} className="skill">
                                {skill.name}
                              </p>
                            ))}
                          </div>
                        )}
                        {job.spells_templates.length > 0 && (
                          <div className="spells">
                            <h5>Sorts ({job.spells_templates.length})</h5>
                            {job.spells_templates.map((spell) => (
                              <p key={spell.id} className="spell">
                                {spell.name}
                              </p>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <h3>Choix du métier</h3>
                  <div className="jobs">
                    {listJobsFree.map((job) => (
                      <div
                        className={`job ${
                          characterJob?.id === job.id ? "selected" : ""
                        }`}
                        key={job.id}
                        onClick={() => {
                          setCharacterJob(job);
                        }}
                      >
                        <h4>{job.name}</h4>
                        <p className="description">{job.description}</p>
                        {job.skills_templates.length > 0 && (
                          <div className="skills">
                            <h5>Compétences ({job.skills_templates.length})</h5>
                            {job.skills_templates.map((skill) => (
                              <p key={skill.id} className="skill">
                                {skill.name}
                              </p>
                            ))}
                          </div>
                        )}
                        {job.spells_templates.length > 0 && (
                          <div className="spells">
                            <h5>Sorts ({job.spells_templates.length})</h5>
                            {job.spells_templates.map((spell) => (
                              <p key={spell.id} className="spell">
                                {spell.name}
                              </p>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Messages d'erreur de l'etape 3 */}
                  {messageErrorStep3.length > 0 && (
                    <div className="error">
                      {messageErrorStep3.map((messageError, index) => (
                        <p key={index}>{messageError}</p>
                      ))}
                    </div>
                  )}
                </div>
                <div className="buttons">
                  <button className="bt" onClick={() => setStep(2)}>
                    Précédent
                  </button>
                  <button
                    className={isStep3Valid ? "bt" : "bt disabled"}
                    disabled={!isStep3Valid}
                    onClick={() => setStep(4)}
                  >
                    Suivant
                  </button>
                </div>
              </>
            )}

            {/* Etape du choix des attributs */}
            {step === 4 && (
              <>
                <div className="step step-4">
                  <h2>Attributs</h2>
                  <p>
                    {attributesPointsUsed <= attributesPointsToUse
                      ? `Points restants : ${
                          attributesPointsToUse - attributesPointsUsed
                        } / ${attributesPointsToUse} `
                      : `Trop de points utilisés veuillez en retirer : ${
                          attributesPointsUsed - attributesPointsToUse
                        }`}
                  </p>
                  <div className="attributes">
                    {allAttributes.map((attribute) => {
                      const attributeUsed = attributesUsedInJob.find(
                        (attr) => attr.name === attribute.name
                      );

                      return (
                        <div className="attribute" key={attribute.name}>
                          <div className="attribute-content">
                            {/* Label */}
                            <div>
                              <label htmlFor={attribute.name}>
                                {attribute.full_name}{" "}
                                <small>({attribute.name})</small>
                              </label>
                            </div>

                            {/* Input et min / max */}
                            <div>
                              <input
                                type="number"
                                name={attribute.name}
                                id={attribute.name}
                                value={
                                  characterAttributes[attribute.name] || ""
                                }
                                max={`${attribute.id === 1 ? 120 : 100}`}
                                min="50"
                                onChange={(e) => {
                                  setCharacterAttributes({
                                    ...characterAttributes,
                                    [attribute.name]: e.target.value,
                                  });
                                }}
                              />
                              <span> / {attribute.id === 1 ? 120 : 100}</span>
                            </div>
                          </div>

                          {/* Affichage des skills et des spells utilisés par l'attribut */}
                          {attributeUsed && (
                            <div className="skills-spells">
                              {attributeUsed.skills.length > 0 && (
                                <div className="skills">
                                  <span className="skills-info">
                                    Compétences ({attributeUsed.skills.length})
                                  </span>{" "}
                                  <span className="skills-list">
                                    {attributeUsed.skills.join(", ")}
                                  </span>
                                </div>
                              )}
                              {attributeUsed.spells.length > 0 && (
                                <div className="spells">
                                  <span className="spells-info">
                                    Sorts ({attributeUsed.spells.length})
                                  </span>{" "}
                                  <span className="spells-list">
                                    {attributeUsed.spells.join(", ")}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}

                          {/* Affichage des messages d'erreur */}
                          {attributeFieldErrors[attribute.name] && (
                            <p className="error">
                              {attributeFieldErrors[attribute.name]}
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* Messages d'erreur de l'etape 4 */}
                  {messageErrorStep4.length > 0 && (
                    <div className="error">
                      {messageErrorStep4.map((messageError, index) => (
                        <p key={index}>{messageError}</p>
                      ))}
                    </div>
                  )}
                </div>
                <div className="buttons">
                  <button className="bt" onClick={() => setStep(3)}>
                    Précédent
                  </button>
                  <button
                    className={isStep4Valid ? "bt" : "bt disabled"}
                    disabled={!isStep4Valid}
                    onClick={() => setStep(5)}
                  >
                    Suivant
                  </button>
                </div>
              </>
            )}

            {/* Etape de confirmation du personnage */}
            {step === 5 && (
              <>
                <div className="step step-5">
                  <h2>Confirmation</h2>
                  <h3>Informations du personnage</h3>
                  <div className="infos">
                    <div className="info">
                      <p>
                        <strong>{characterName}</strong>
                      </p>
                      {characterNickname && <p>Surnom : {characterNickname}</p>}

                      <p>{characterGender === "H" ? "Homme" : "Femme"}</p>
                      <p>Age : {characterAge}</p>
                      <p>Beauté : {characterBeauty}</p>
                      {characterDescription && (
                        <p>Description : {characterDescription}</p>
                      )}
                    </div>
                  </div>
                  <div>
                    <h3>Métiers</h3>
                    <h4>Région de départ</h4>
                    <div className="regions">
                      <div className="region">
                        <h4>{characterRegion.name}</h4>
                        <p className="description">
                          {characterRegion.description}
                        </p>
                        {characterRegion.skills_templates.length > 0 && (
                          <div className="skills">
                            <h5>
                              Compétences (
                              {characterRegion.skills_templates.length})
                            </h5>
                            {characterRegion.skills_templates.map((skill) => (
                              <p className="skill" key={skill.id}>
                                {skill.name}
                              </p>
                            ))}
                          </div>
                        )}
                        {characterRegion.spells_templates.length > 0 && (
                          <div className="spells">
                            <h5>
                              Sorts ({characterRegion.spells_templates.length})
                            </h5>
                            {characterRegion.spells_templates.map((spell) => (
                              <p className="spell" key={spell.id}>
                                {spell.name}
                              </p>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <h4>Métiers des parents</h4>
                    <div className="jobs-parents">
                      {characterJobsParental.map((job) => (
                        <div className="job-parent" key={job.id}>
                          <h4>{job.name}</h4>
                          <p className="description">{job.description}</p>
                          {job.skills_templates.length > 0 && (
                            <div className="skills">
                              <h5>
                                Compétences ({job.skills_templates.length})
                              </h5>
                              {job.skills_templates.map((skill) => (
                                <p className="skill" key={skill.id}>
                                  {skill.name}
                                </p>
                              ))}
                            </div>
                          )}
                          {job.spells_templates.length > 0 && (
                            <div className="spells">
                              <h5>Sorts ({job.spells_templates.length})</h5>
                              {job.spells_templates.map((spell) => (
                                <p className="spell" key={spell.id}>
                                  {spell.name}
                                </p>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <h4>Métier choisit</h4>
                    <div className="jobs-select">
                      <div className="jobs">
                        <div className="job">
                          <h4>{characterJob.name}</h4>
                          <p className="description">
                            {characterJob.description}
                          </p>
                          {characterJob.skills_templates.length > 0 && (
                            <div className="skills">
                              <h5>
                                Compétences (
                                {characterJob.skills_templates.length})
                              </h5>
                              {characterJob.skills_templates.map((skill) => (
                                <p className="skill" key={skill.id}>
                                  {skill.name}
                                </p>
                              ))}
                            </div>
                          )}
                          {characterJob.spells_templates.length > 0 && (
                            <div className="spells">
                              <h5>
                                Sorts ({characterJob.spells_templates.length})
                              </h5>
                              {characterJob.spells_templates.map((spell) => (
                                <p className="spell" key={spell.id}>
                                  {spell.name}
                                </p>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <h3>Attributs</h3>
                  <div className="attributes">
                    {allAttributes.map((attribute) => (
                      <div className="attribute" key={attribute.name}>
                        <div className="attribute-content">
                          <span>
                            {attribute.full_name}{" "}
                            <small>({attribute.name})</small>
                          </span>
                          <span>{characterAttributes[attribute.name]}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="buttons">
                  <button className="bt" onClick={() => setStep(4)}>
                    Précédent
                  </button>
                  <button
                    className={isFormValid ? "bt" : "bt disabled"}
                    disabled={!isFormValid}
                    onClick={handleAddCharacter}
                  >
                    Valider
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CharacterNew;
